import router from "@/router";
import {useUserBillboard} from "@/hook/useUserBillboard";
import http from "@/api";
import {AxiosDefaultOption} from "@/api/interface/configure";

/**
 * API（僅本檔使用 → 內聯實作，不另立 api/module）：公布欄統計 GET /api/billboard/statistics
 */
const apiStatistics = () =>
    http.get(`/api/billboard/statistics`, {}, {opts: AxiosDefaultOption});

/**
 * 公布欄輪詢
 *
 * 取代原 `useWebsocket`（/websocket/notify 收 billboardSummary 即時推播）。
 * 後端 WebSocket 服務已移除，改以定時輪詢既有 REST `getBillboardStatistics()`
 * 自動刷新公布欄；即時刷新的實體動作與原 WebSocket 的 onFetch 完全相同。
 */
export const useBillboardPolling = () => {

    const {
        setUserBillboard
    } = useUserBillboard()

    /**
     * 輪詢計時器
     */
    let timer = null

    /**
     * 取值（比照原 useWebsocket.onFetch：REST 撈公布欄統計 → 投入 → 於列表/內容頁刷新）
     * 路由於每次輪詢即時讀取，避免掛載當下捕捉造成的過期。
     */
    const onFetch = (page) => {

        apiStatistics().then(r => {

            //如果沒返回正確, 不往下執行
            if (r.data?.result !== true) return false

            //投入資料
            setUserBillboard(r.data.data)

            const name = router.currentRoute.value.name

            //在列表頁面
            if (name === `Billboard`) page.value.initial()

            //在內容頁面
            else if (name === `BillboardEdit`) page.value.initial(false)

        })

    }

    /**
     * 開始輪詢（先立即抓一次, 再依間隔定時輪詢）
     *
     * @param page     目前頁面的 ref
     * @param interval 輪詢間隔 (毫秒), 預設 30 秒（公布欄為被動通知, 較 QR 登入寬鬆）
     */
    const startBillboardPolling = (
        page,
        interval = 30 * 1000
    ) => {

        stopBillboardPolling()

        onFetch(page)

        timer = setInterval(() => onFetch(page), interval)

    }

    /**
     * 停止輪詢
     */
    const stopBillboardPolling = () => {

        if (timer !== null) clearInterval(timer)

        timer = null

    }

    return {
        startBillboardPolling,
        stopBillboardPolling
    }

}
